import React from 'react';
import { LogoProps } from './logo.props';
import Link from 'next/link';

export const LogoMolecule = (props: LogoProps) => {
  return (
    <h1 data-cy="logo" className="flex text-center m-0 p-0 mx-auto">
      <Link href="https://www.hiwaldo.com/">
        <a
          aria-label="Welcome To WALDO"
          className="color-waldo-blue flex self-center mx-auto"
        >
          <img
            className={`block w-44 ${props.className}`}
            src="/images/logo.svg"
            alt="Logo"
          />
        </a>
      </Link>
    </h1>
  );
};
